import * as Dialog from '@radix-ui/react-dialog';
import { useMutation } from '@tanstack/react-query';
import { Button } from 'components/ui/button';
import { botOperationServices } from 'features/bot-builder/services/botOperations';
import { Bot } from 'features/bot-builder/types/apiResponses';
import { LoaderIcon } from 'lucide-react';
import { useState } from 'react';
import toast from 'react-hot-toast';

const SaveChanges = ({
  isDisabled,
  botChanges,
  id,
  setIsConfig,
}: {
  isDisabled: boolean;
  botChanges: Partial<Bot>;
  id: string;
  setIsConfig: (value: boolean) => void;
}) => {
  const [open, setOpen] = useState<boolean>(false);
  console.log(botChanges);

  const saveBotChanges = useMutation({
    mutationKey: ['saveChanges'],
    mutationFn: ({ id, data }: { id: string; data: Partial<Bot> }) =>
      botOperationServices.updateBot(id, data),

    onSuccess: () => {
      toast.success(`${botChanges.name} updated successfully`);
      setIsConfig(false);
      setOpen(false);
    },
    onError: () => {
      toast.error('Failed to save changes');
    },
  });

  const handleSave = (id: string, botChanges: Partial<Bot>) => {
    saveBotChanges.mutate({ id, data: botChanges });
  };

  return (
    <Dialog.Root open={open} onOpenChange={setOpen}>
      <Dialog.Trigger asChild>
        <Button
          className="text-[14px] font-medium w-full bg-secondary"
          variant="customSecondary"
          disabled={isDisabled}
        >
          Save changes
        </Button>
      </Dialog.Trigger>
      <Dialog.Overlay className="fixed inset-0 bg-background-overlay/70" />
      <Dialog.Content className="absolute text-text-primary z-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-background-card rounded-lg shadow-lg p-4 sm:p-6 w-[90%] sm:w-[480px] max-w-[480px] flex flex-col gap-1 sm:mx-4">
        <Dialog.Title className="text-xl sm:text-2xl text-left font-bold text-primary">
          Save changes
        </Dialog.Title>
        <Dialog.Description className="max-w-full mt-2 text-left text-[14px] sm:text-[15px] font-normal">
          Are you sure you want to save the changes made to the bot?
        </Dialog.Description>
        <form className="flex flex-col sm:flex-row justify-end mt-4 sm:mt-6 w-full gap-2">
          <Button
            variant="customSecondary"
            size="sm"
            onClick={() => setOpen(false)}
            className="text-[14px] bg-secondary w-full sm:w-auto"
          >
            Cancel
          </Button>

          <Button
            variant="customSecondary"
            size="sm"
            className="text-[14px] bg-secondary w-full sm:w-auto"
            disabled={saveBotChanges.isPending}
            type="button"
            onClick={() => handleSave(id, botChanges)}
          >
            {saveBotChanges.isPending && (
              <div className="animate-spin">
                <LoaderIcon size={20} />
              </div>
            )}
            <span>Save</span>
          </Button>
        </form>
      </Dialog.Content>
    </Dialog.Root>
  );
};

export default SaveChanges;
